export enum OcrStatus {
  ok = 'ok',
  manual = 'manual',
  inProgress = 'in_progress'
}
